import { translate } from "@/i18n/i18n";
import { FC } from "react";

export const Ready: FC = () => {
    return (
        <div className="relative w-[100%] h-[100%] px-3 flex flex-col justify-center items-center text-2xl">
            <div className="z-10">
                <img src="https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_19b1cfbfc4a749eca6ed63ce21112215/default/dark/3.0" style={{ display: "inline", position: "relative", top: "-2px", height: "2.5rem" }}/>
                <img src="https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_032e2c9c44604e8b82e5ee1bf3cb496c/default/dark/3.0" style={{ display: "inline", position: "relative", top: "-2px", height: "2.5rem" }}/>
                <img src="https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_14e53a08453544f2bb346b3b91ea29e8/default/dark/3.0" style={{ display: "inline", position: "relative", top: "-2px", height: "2.5rem" }}/>
                { translate("DONO_TRAIN_IS_READY") }
            </div>
        </div>
    );
}